import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "cart-card" }
const _hoisted_2 = { class: "cart-card__left-content" }
const _hoisted_3 = { class: "cart-card__info" }
const _hoisted_4 = { class: "cart-card__name" }
const _hoisted_5 = { class: "cart-card__weight" }
const _hoisted_6 = { class: "cart-card__prices" }
const _hoisted_7 = { class: "cart-card__price cart-card__price--actual" }
const _hoisted_8 = {
  key: 0,
  class: "cart-card__price cart-card__price--old"
}
const _hoisted_9 = { class: "cart-card__quantity-controller" }
const _hoisted_10 = { class: "cart-card__right-content" }
const _hoisted_11 = { class: "cart-card__image" }
const _hoisted_12 = ["src", "alt"]

import { computed, PropType } from 'vue';
import { Product, ShippingCartProduct } from '@/types/app';
import helpers from '@/helpers';
import AppBtn from '@/components/AppBtn.vue';
import IconTrash from '@/icons/icon-trash.vue';
import QuantityPanelV2 from '@/components/QuantityPanelV2.vue';
import useShoppingCartStore from '@/store/shopping-cart';
import useProductsStore from '@/store/products';


export default /*#__PURE__*/_defineComponent({
  __name: 'CartCard',
  props: {
  cartProduct: {
    type: Object as PropType<ShippingCartProduct>,
    required: true,
  },
},
  setup(__props) {

const shoppingCartStore = useShoppingCartStore();
const productsStore = useProductsStore();

const props = __props;

const product = computed<Product>(() => props.cartProduct?.product);
const inStockQuantity = computed(() => productsStore.getProductQuantity(product.value.productId));
const inStock = computed(() => inStockQuantity.value > 0);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(product.value.name), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(product.value.weight) + _toDisplayString(product.value.weightUnitLabel), 1),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(helpers).formatCurrency(product.value.special || product.value.price)), 1),
          (product.value.special)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(helpers).formatCurrency(product.value.price)), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(`cart-card__stock ${inStockQuantity.value < 1 ? 'cart-card__stock--not-in-stock' : ''}`)
        }, _toDisplayString(inStock.value
              ? _ctx.$t('inStock', { quantity: inStockQuantity.value })
              : _ctx.$t('notInStock')), 3)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(AppBtn, {
          size: "sm",
          class: _normalizeClass(`cart-card__remove-btn ${inStock.value ? '' : 'cart-card__remove-btn--full'}`),
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => _unref(shoppingCartStore).removeProduct(product.value), ["prevent"]))
        }, {
          "icon-left": _withCtx(() => [
            _createVNode(IconTrash)
          ]),
          _: 1
        }, 8, ["class"]),
        (inStock.value)
          ? (_openBlock(), _createBlock(QuantityPanelV2, {
              key: 0,
              "model-value": __props.cartProduct.quantity,
              max: __props.cartProduct.product.quantity,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = (quantity) => _unref(shoppingCartStore)
            .changeProductQuantity([{ product: product.value, quantity }]))
            }, null, 8, ["model-value", "max"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("img", {
          src: product.value.images[0].thumb,
          alt: product.value.name
        }, null, 8, _hoisted_12)
      ])
    ])
  ]))
}
}

})